import { render, staticRenderFns } from "./PopularItems.vue?vue&type=template&id=38db49f3&scoped=true&"
import script from "./PopularItems.vue?vue&type=script&lang=js&"
export * from "./PopularItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38db49f3",
  null
  
)

export default component.exports